import { Component, Input, OnInit } from '@angular/core';
import { PlantillaComponent } from '../plantilla.component';
import moment from 'moment';
import 'moment/locale/es';
import { AppSettings } from '../../../../proyect.conf';
import { NotificacioneSarlaft } from '../../../_models/sarlaft';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { firstValueFrom, forkJoin, lastValueFrom } from 'rxjs';
import { RolFuncionalitiesServices } from '../../../_services/rol-funcionalidad.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Router } from '@angular/router';
import { SocketConexion } from '../../../_services/socket-conexion.service';
import swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { sleep } from '../../../utils/utilidades';
import { ListasolicitudessocketService } from '../../../_services/listasolicitudessocket.service';
import { Funcionalidades, NotificacionesPushEnum } from '../../../_enums/enum';
import { NotificacionesPush, NotificacionsGestiones } from '../../../_models/notificaciones-push';
import { TasasVariablesCondicionesNotificacionesService } from '../../../_services/tasas-variables-condiciones-notificaciones.service';
import { UsuarioNotificacionService } from '../../../_services/usuario-notificacion.service';
import { SolicitudService } from '../../../_services/solicitud.service';
import { Solicitud } from '../../../_models/solicitud';
import { CanalRolService } from '../../../_services/canal-rol.service';
import { CanalRestriccionGestionEstadoService } from '../../../_services/canal-restriccion-gestion-estado.service';
import { UsuarioComisionFreelance } from '../../../_models/usuario-comision-freelance';
import { UsuarioComisionFreelanceService } from '../../../_services/usuario-comision-freelance.service';
import { EstadoRol } from '../../../_models/estado-rol';
import { EstadoRolService } from '../../../_services/estado-rol.service';
import { ContactEstadoSolicitud } from '../../../_models/contact-estado-solicitud';
import { ContactEstadosSolicitudesService } from '../../../_services/contact-estados-solicitudes.service';
import { ConfiguracionesCanales } from '../../../_models/configuraciones-canales';
import { ConfiguracionesCanalesService } from '../../../_services/configuraciones-canales.service';
import { Usuario } from '../../../_models/usuario';
import { NotificacionesGestionesService } from '../../../_services/notificaciones-gestiones.service';
import { SolicitudUnidadCreditoService } from '../../../_services/solicitud-unidad-credito.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-barra-superior',
  templateUrl: './barra-superior.component.html',
  styleUrls: ['./barra-superior.component.css']
})

export class BarraSuperiorComponent implements OnInit {

  @Input() usuLogueado: any;
  @Input() rutImagen: string;
  @Input() nombre: string;
  @Input() usuRoles: string[] = [];
  fecha: string;
  enviroment: string;
  esFullScreen = false;
  notificaciones: NotificacionesPush[];
  public notificacionesRecibidas: NotificacionesPush[];
  public notificacionesEnEspera: NotificacionesPush[];
  cargando = false
  isNotificationsOpen = false;
  nRecibidas: number = 0;
  nNoLeidas: number = 0;
  nEnviadas: number = 0;
  selectedTab = 1;
  permisos = { sarlaftGestionDocumental: false, sarlaftGestionRiesgo: false, escuchar: false, gestionarFlujo: false, bloquear: false, alivio: false, verFreelance: false, comite: false, linkRetoma: false };
  lisSolicitudSocket: any[] = [];
  backgroundNameenviroment = '#138e38';

  solicitud: Solicitud;
  rolUsuario: string[] = [];
  usuarioComisionFreelance: UsuarioComisionFreelance;
  respUsuarioComisionFreelance: UsuarioComisionFreelance;
  estRoles: EstadoRol[] = [];
  lisCentroLlamadaEstados: ContactEstadoSolicitud[] = [];
  consultarAprobacion: any;
  lisConfiguracionCanalEstados: ConfiguracionesCanales[] = [];
  usuario: Usuario;
  objLazy = {
    idUsuario: null,
    pagina: 0,
    cantidad: 50
  };
  deshabilitarCarga: boolean = false;
  cargandoMas: boolean = false;
  constructor(public app: PlantillaComponent,
    private nav: NavService,
    private location: Location,
    private rolFuncionalidadService: RolFuncionalitiesServices,
    private autServicio: AutenticacionService,
    private router: Router,
    private socketConexion: SocketConexion,
    private translateService: TranslateService,
    private lisStudesSocketService: ListasolicitudessocketService,
    private tasasVariablesCondicionesNotificacionesService: TasasVariablesCondicionesNotificacionesService,
    private usuarioNotificacionService: UsuarioNotificacionService,
    private solServicio: SolicitudService,
    private canRolServicio: CanalRolService,
    private canalRestriccionGestionEstadoService: CanalRestriccionGestionEstadoService,
    private usuarioComisionFreelanceService: UsuarioComisionFreelanceService,
    private estRolesServicio: EstadoRolService,
    private cenLlamadaEstadoServicio: ContactEstadosSolicitudesService,
    private conCanalEstadoServicio: ConfiguracionesCanalesService,
    private notificacionesGestionesService: NotificacionesGestionesService,
    private solicitudUnidadCreditoService: SolicitudUnidadCreditoService,
    private conServicio: ConfirmationService,
  ) {
  }

  ngOnInit() {
    this.conectarSocket();
    this.cargando = true
    this.obtenerFechaActual();
    this.usuario = this.autServicio.obtenerUsuario();
    this.objLazy.idUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    this.objLazy.pagina = 0;
    this.deshabilitarCarga = false;
    this.enviroment = AppSettings.nameEnviroment;
    if (this.enviroment === 'Prepro') {
      this.backgroundNameenviroment = '#ff0000';
      this.enviroment = 'Preproducción';
    }
    forkJoin(
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GDSARLAFT', 'SARLAFTGD', 'GEDOSA'),
      this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GRSARLAFT', 'SARLAFTGR', 'GERISA'),
      this.notificacionesGestionesService.obtenerNotificacionesUsuario(this.objLazy)
    ).subscribe(
      ([sarlaftGestionDocumental, sarlaftGestionRiesgo, notificaciones]) => {
        this.permisos.sarlaftGestionDocumental = !!sarlaftGestionDocumental.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
        this.permisos.sarlaftGestionRiesgo = !!sarlaftGestionRiesgo.find(x => !!this.autServicio.obtenerRolesUsuarios().find(y => x.codigoRol === y));
        this.notificaciones = notificaciones.data || [];
        this.nRecibidas = notificaciones.cantidad || 0;
        this.nNoLeidas = notificaciones.noLeidas || 0;
        if (this.notificaciones.length < this.objLazy.cantidad) {
          this.deshabilitarCarga = true;
        }
        this.cargarNotificaciones();
        this.cargando = false
      }
    )
  }

  conectarSocket() {
    this.socketConexion.socket.on('gestionSolicitudCompleto', (data) => {
      this.lisStudesSocketService.actualizarListaSolicitudesSocket(data);
    });
    this.socketConexion.socket.emit('gestionSolicitudCompleto', {
      conectar: true
    });
  }

  cargarNotificaciones() {
    if (!this.notificaciones) {
      this.msgError();
    }
    this.actualizarListas(true);
  }

  async actualizarListas(bandera: boolean = false) {
    if (!bandera) {
      this.objLazy.pagina = 0;
      this.deshabilitarCarga = false;
      this.notificaciones = [];
      const res: NotificacionsGestiones = await firstValueFrom(
        this.notificacionesGestionesService.obtenerNotificacionesUsuario(this.objLazy));
      this.notificaciones = res.data || [];
      this.nRecibidas = res.cantidad || 0;
      this.nNoLeidas = res.noLeidas || 0;
      if (!this.notificaciones || this.notificaciones.length < this.objLazy.cantidad) {
        this.deshabilitarCarga = true;
      }
    }

    // Ordenar notificaciones de más reciente a más antigua (descendente)
    if (this.notificaciones && this.notificaciones.length > 0) {
      this.notificaciones.sort((a, b) => new Date(b.fechaEnvio).getTime() - new Date(a.fechaEnvio).getTime());
    }

    this.notificaciones.forEach(notificacion => {
      const fechaEnvio = new Date(notificacion.fechaEnvio);
      const fecha = `${fechaEnvio.getDate().toString().padStart(2, '0')}-${(fechaEnvio.getMonth() + 1).toString().padStart(2, '0')}-${fechaEnvio.getFullYear()}`;
      const hora = fechaEnvio.toLocaleString('es-CO', { hour: '2-digit', minute: '2-digit', hour12: true });
      notificacion.fechaEnvioFecha = fecha;
      notificacion.fechaEnvioHora = hora;
    });

    this.notificacionesRecibidas = this.notificaciones.filter(notificacion => !notificacion.indicadorGestionado);
    this.notificacionesEnEspera = this.notificaciones.filter(notificacion => notificacion.indicadorLeido && !notificacion.indicadorGestionado && notificacion.codigoLinkNotificacion === NotificacionesPushEnum.SARLAFT);
    this.nEnviadas = this.notificacionesEnEspera.length;
  }

  changeScreen() {
    if (this.esFullScreen) {
      this.cerrarFullScreen();
    } else {
      this.abrirFullScreen();
    }
  }

  obtenerFechaActual() {
    this.fecha = moment().format('dddd, DD [de] MMMM [de] YYYY');
  }

  abrirFullScreen() {
    const docElmWithBrowsersFullScreenFunctions = document.documentElement as HTMLElement & {
      mozRequestFullScreen(): Promise<void>;
      webkitRequestFullscreen(): Promise<void>;
      msRequestFullscreen(): Promise<void>;
    };

    if (docElmWithBrowsersFullScreenFunctions.requestFullscreen) {
      docElmWithBrowsersFullScreenFunctions.requestFullscreen();
    } else if (docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen) { /* Firefox */
      docElmWithBrowsersFullScreenFunctions.mozRequestFullScreen();
    } else if (docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      docElmWithBrowsersFullScreenFunctions.webkitRequestFullscreen();
    } else if (docElmWithBrowsersFullScreenFunctions.msRequestFullscreen) { /* IE/Edge */
      docElmWithBrowsersFullScreenFunctions.msRequestFullscreen();
    }
    this.esFullScreen = true;
  }

  cerrarFullScreen() {
    const docWithBrowsersExitFunctions = document as Document & {
      mozCancelFullScreen(): Promise<void>;
      webkitExitFullscreen(): Promise<void>;
      msExitFullscreen(): Promise<void>;
    };
    if (docWithBrowsersExitFunctions.exitFullscreen) {
      docWithBrowsersExitFunctions.exitFullscreen();
    } else if (docWithBrowsersExitFunctions.mozCancelFullScreen) { /* Firefox */
      docWithBrowsersExitFunctions.mozCancelFullScreen();
    } else if (docWithBrowsersExitFunctions.webkitExitFullscreen) { /* Chrome, Safari and Opera */
      docWithBrowsersExitFunctions.webkitExitFullscreen();
    } else if (docWithBrowsersExitFunctions.msExitFullscreen) { /* IE/Edge */
      docWithBrowsersExitFunctions.msExitFullscreen();
    }
    this.esFullScreen = false;
  }

  async toggleNotifications() {
    if (this.nRecibidas === 0 && this.nEnviadas === 0) {
      this.msgSinNotificaciones();
      return;
    } else {
      this.isNotificationsOpen = !this.isNotificationsOpen;
    }
  }

  closeNotifications() {
    this.isNotificationsOpen = false;
  }

  changeTab(tabNumber: number) {
    this.selectedTab = tabNumber;
  }

  msgError() {
    this.nav.setMesage(0, {
      severity: 'info', summary: this.nav.buscarMensaje('LBL_ADVERTENCIA'),
      detail: this.nav.buscarMensaje('SARLAFT.MSG_MODALMALCONFIGURADA')
    });
    this.cargando = false;
    this.toggleNotifications();
  }

  msgSinNotificaciones() {
    this.nav.setMesage(0, {
      severity: 'info', summary: this.nav.buscarMensaje('LBL_ADVERTENCIA'),
      detail: this.nav.buscarMensaje('SARLAFT.MSG_MSGRSINNOTIFICACIONES')
    });

  }
  msgSinPersmisos() {
    this.nav.setMesage(0, {
      severity: 'info', summary: this.nav.buscarMensaje('LBL_ADVERTENCIA'),
      detail: this.nav.buscarMensaje('SARLAFT.MSG_MSGRSINPERMISOSCONFIGURADOS')
    });
  }

  async gestionRecibidas(event: any, item: NotificacionesPush) {
    const elemento = event.currentTarget;
    elemento.classList.add('eliminar');
    setTimeout(() => { elemento.remove(); }, 1000);
    this.cargando = true;
    this.notificaciones = [];
    let condicionActualizar: NotificacionesPush = null;
    const res: NotificacionsGestiones = await firstValueFrom(
      this.notificacionesGestionesService.obtenerNotificacionesUsuario(this.objLazy));
    this.notificaciones = res.data || [];

    if (Array.isArray(this.notificaciones)) {
      condicionActualizar = this.notificaciones.find(
        notificacion => notificacion.idNotificacionGestion === item.idNotificacionGestion
      );
    }

    if (!condicionActualizar) {
      this.nav.setMesage(0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_ADVERTENCIA'),
        detail: this.nav.buscarMensaje('MSG_NOTIFICACIONATENDIDA')
      });
      this.actualizarListas();
      this.cargando = false;
      return;
    }
    const uniSeleccionada = condicionActualizar.idRelacionado
      ? await firstValueFrom(this.solicitudUnidadCreditoService.obtener(condicionActualizar.idRelacionado))
      : null;
    this.solicitud = condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.SARLAFT || condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.TASAESPECIAL ?
      await firstValueFrom(this.solServicio.obtener(condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.SARLAFT ? uniSeleccionada.idSolicitud : condicionActualizar.idRelacionado)) : null;

    if (condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.SARLAFT) {
      this.notificacionesGestionesService.marcarLeido(condicionActualizar.idNotificacionGestionUsuario).subscribe(
        async (res: any) => {
          this.toggleNotifications();
          // Validacion del socket
          const existe = this.lisStudesSocketService.obtenerListaSolicitudesSocket().find(x => x.idSolicitud === uniSeleccionada.idSolicitud);
          if (!!existe && existe.idUsuario !== this.usuLogueado.idUsuario) {
            // this.validandoIndicador = true;
            const mensajeSwalTerceroOcupado = {
              title: this.nav.buscarMensaje('MSG_GESTIONSOLICITUD'),
              html: await this.translateService.get('MSG_MENSAJEUSUARIOGESTION', {
                value: existe.usuario
              }).toPromise(),
              allowOutsideClick: false,
              allowEscapeKey: false,
              imageUrl: '/assets/images/info.png',
              imageHeight: 64,
              confirmButtonText: this.nav.buscarMensaje('BTN_CERRAR'),
              preConfirm: () => {
              }
            };
            swal(mensajeSwalTerceroOcupado);
            // this.validandoIndicador = false;
            this.actualizarListas();
            this.cargando = false;
            return;
          }
          this.actualizarListas();
          this.cargando = false;

          const rutaBase = 'pys/gestion-comercial/';
          if (this.permisos.sarlaftGestionRiesgo && condicionActualizar.indicadorRiesgo) {
            if (!existe && uniSeleccionada) {
              this.router.navigate([rutaBase], { replaceUrl: true });
              await sleep(30);
            }
            const ruta = rutaBase + 'gestion-riesgo/' + uniSeleccionada.idSolicitud;
            this.router.navigate([ruta]);
          } else if (this.permisos.sarlaftGestionDocumental && !condicionActualizar.indicadorRiesgo && uniSeleccionada) {
            if (!existe && uniSeleccionada) {
              this.router.navigate([rutaBase], { replaceUrl: true });
              await sleep(30);
            }
            if (condicionActualizar.idRelacionado) {
              const ruta = uniSeleccionada.idPlataformaDigital ? 'pys/fabrica-credito' : rutaBase + 'gestion-documental/' + uniSeleccionada.idSolicitud;
              this.router.navigate([ruta]);
            }
          } else {
            this.msgSinPersmisos();
          }
        },
        (err: Error) => {
          this.msgError();
          this.cargando = false;
        }
      );
    } else if (condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.TASAS) {
      this.notificacionesGestionesService.marcarLeido(condicionActualizar.idNotificacionGestionUsuario).subscribe(
        (res: any) => {
          this.toggleNotifications();
          this.actualizarListas();
          this.cargando = false;
          const rutaBase = 'apl/tasas-variables/actualizar/' + condicionActualizar.idPadre
          this.router.navigate([rutaBase], { replaceUrl: true });
        }
      )
    } else if (condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.ENTHUELLANOIDEN) {
      this.notificacionesGestionesService.marcarLeido(condicionActualizar.idNotificacionGestionUsuario).subscribe(res => {
        this.toggleNotifications();
        this.actualizarListas();

        this.cargando = false;
      })
    } else if (condicionActualizar.codigoLinkNotificacion === NotificacionesPushEnum.SOLICITUDLIBRANZA) {
      try {
        const [
          solicitud,
          rolesUsuario,
          alivio,
          perGestionar,
          lisRolFuncionalidad,
          lisCanalesEstados,
          lisCentroLlamadaEstados,
          estRoles,
          respUsuarioComisionFreelance
        ] = await Promise.all([
          lastValueFrom(this.solServicio.obtener(uniSeleccionada.idSolicitud)),
          this.autServicio.obtenerRolesUsuarios(),
          lastValueFrom(this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'RADALV', 'BTNRALV')),
          lastValueFrom(this.rolFuncionalidadService.getByCodigoPadreCodigoHijo('GCOMERCIAL', 'FLUVENTA', 'GESTIONAR')),
          lastValueFrom(this.rolFuncionalidadService.getAllByCodigoFuncionalidadYUsuario(Funcionalidades.COMITECREDITO, this.autServicio.obtenerIdUsuarioLogueado())),
          lastValueFrom(this.conCanalEstadoServicio.listadoHabilitados()),
          lastValueFrom(this.cenLlamadaEstadoServicio.listadoHabilitados()),
          lastValueFrom(this.estRolesServicio.listadoHabilitados()),
          lastValueFrom(this.usuarioComisionFreelanceService.obtenerPorIdUsuario(this.usuario.idUsuario))
        ]);
        this.solicitud = solicitud;
        this.rolUsuario = rolesUsuario;
        this.permisos.alivio = alivio.some(x => rolesUsuario.includes(x.codigoRol));
        this.permisos.gestionarFlujo = perGestionar.some(x => rolesUsuario.includes(x.codigoRol));
        this.permisos.comite = lisRolFuncionalidad.some(x => x.indicadorInsertar);
        this.lisConfiguracionCanalEstados = lisCanalesEstados;
        this.lisCentroLlamadaEstados = lisCentroLlamadaEstados;
        this.estRoles = estRoles;
        this.respUsuarioComisionFreelance = respUsuarioComisionFreelance;
        const restriccionGestionPorEstados = await this.verificarRestriccionGestionPorEstados(this.solicitud);
        if (await this.validarSolicitud(this.solicitud, restriccionGestionPorEstados)) {
          this.continuar(this.solicitud, condicionActualizar);
        } else {
          this.nav.setMesage(0, {
            severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
            detail: this.nav.buscarMensaje('GESTIONCOMERCIAL.MSG_NOTIENEPERMISOS')
          });
        }
      } catch (error) {
        console.error('Error al cargar la solicitud:', error);
      } finally {
        this.toggleNotifications();
        this.actualizarListas();
        this.cargando = false;
      }
    } else {
      this.notificacionesGestionesService.marcarLeido(condicionActualizar.idNotificacionGestionUsuario).subscribe(
        (res: any) => {
          this.toggleNotifications();
          const elemento = this.notificaciones.find(x => x.idNotificacionGestionUsuario === condicionActualizar.idNotificacionGestionUsuario);
          if (elemento) {
            this.notificacionesRecibidas = this.notificacionesRecibidas.map(x =>
              x.idNotificacionGestionUsuario === condicionActualizar.idNotificacionGestionUsuario
                ? { ...x, indicadorLeido: true }
                : x
            );
          }

          this.cargando = false;
          if (condicionActualizar.urlRedireccion) {
            window.open(condicionActualizar.urlRedireccion, '_blank', 'noopener,noreferrer');
            return;
          }
          const rutaBase = 'pys/gestion-comercial';
          const filtro = { state: { idEstado: this.solicitud.idEstado, numeroDocumento: this.solicitud.numeroDocumentoTerceroSolicitante } };
          const currentUrl = this.router.url;
          if (currentUrl.startsWith(`/${rutaBase}`)) {
            this.router.navigate(['temporary-route']).then(() => {
              this.router.navigate([rutaBase], { ...filtro, replaceUrl: true });
            });
          } else {
            this.router.navigate([rutaBase], { ...filtro, replaceUrl: true });
          }
          this.actualizarListas();
        }
      )
    }
  }

  async gestionEnEspera(event: any, item: any) {
    const elementoClicado = event.currentTarget;
    elementoClicado.classList.add('clicked');
    setTimeout(() => { elementoClicado.classList.remove('clicked'); }, 300);
    this.notificaciones = [];
    const res: NotificacionsGestiones = await firstValueFrom(
      this.notificacionesGestionesService.obtenerNotificacionesUsuario(this.objLazy));
    this.notificaciones = res.data || [];

    const condicionActualizar = this.notificaciones.find(notificacion => notificacion.idNotificacionGestionUsuario === item.idNotificacionGestionUsuario);
    if (!condicionActualizar) {
      this.location.back();
    }

    const uniSeleccionada = condicionActualizar.idRelacionado
      ? await this.solicitudUnidadCreditoService.obtener(condicionActualizar.idRelacionado).toPromise()
      : null;

    // Validacion del socket
    const existe = this.lisStudesSocketService.obtenerListaSolicitudesSocket().find(x => x.idSolicitud === uniSeleccionada.idSolicitud);

    if (!!existe && existe.idUsuario !== this.usuLogueado.idUsuario) {
      // this.validandoIndicador = true;
      const mensajeSwalTerceroOcupado = {
        title: this.nav.buscarMensaje('MSG_GESTIONSOLICITUD'),
        html: await this.translateService.get('MSG_MENSAJEUSUARIOGESTION', {
          value: existe.usuario
        }).toPromise(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        imageUrl: '/assets/images/info.png',
        imageHeight: 64,
        confirmButtonText: this.nav.buscarMensaje('BTN_CERRAR'),
        preConfirm: () => {
        }
      };
      swal(mensajeSwalTerceroOcupado);
      // this.validandoIndicador = false;
      this.actualizarListas();
      return;
    }

    this.actualizarListas();
    const rutaBase = 'pys/gestion-comercial/';
    if (this.permisos.sarlaftGestionRiesgo && condicionActualizar.indicadorRiesgo) {
      if (!existe && uniSeleccionada) {
        this.router.navigate([rutaBase], { replaceUrl: true });
        await sleep(30);
      }
      const ruta = rutaBase + 'gestion-riesgo/' + uniSeleccionada.idSolicitud;
      this.router.navigate([ruta], { replaceUrl: true });
    } else if (this.permisos.sarlaftGestionDocumental && !condicionActualizar.indicadorRiesgo && uniSeleccionada) {
      if (!existe) {
        this.router.navigate([rutaBase], { replaceUrl: true });
        await sleep(30);
      }
      const ruta = uniSeleccionada.idPlataformaDigital ? 'pys/fabrica-credito' : rutaBase + 'gestion-documental/' + uniSeleccionada.idSolicitud;
      this.router.navigate([ruta], { replaceUrl: true });
    } else {
      this.msgSinPersmisos();
    }
  }

  async verificarRestriccionGestionPorEstados(row: any) {
    if (row.indicadorRestriccionGestion) {
      const [rolCanales, lisCanalesRestriccionesGestionXEstados] =
        await forkJoin(
          this.canRolServicio.obtenerPorIdCanal(row.idCanal),
          this.canalRestriccionGestionEstadoService.obtenerPorCanalHabilitados(row.idCanal)
        ).toPromise();
      if (rolCanales.find(
        x => x.indicadorHabilitado &&
          x.codigoRol === this.rolUsuario.find(s => s === x.codigoRol))) {
        return false;
      } else {
        if (
          lisCanalesRestriccionesGestionXEstados.find(x => x.idEstado === row.idEstado)) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  async validarSolicitud(row: any, restriccionGestionPorEstados: any) {
    return !this.validarSiTieneIndicadorFreelance(row) && !restriccionGestionPorEstados &&
      (!row.idPlataformaDigital || (row.idPlataformaDigital && row.indicadorAsignarEjecutivo)) &&
      (row.idSolicitud && !row.indicadorEstadoFinal && !row.indicadorBloqueado && (!row.indicadorCheckDocumental ||
        !row.indicadorCreadoMovil) && (row.indicadorCreadoMovil || !this.validarEstadoContact(row.idEstado)) &&
        this.verRadicar(row) && !row.indicadorRestringido && (!row.indicadorAlivios || this.permisos.alivio));
  }

  cargarUsuarioComisionFreelance() {
    if (!this.usuario || this.autServicio.obtenerNivelMaximo() !== 1) {
      return;
    }
    this.usuarioComisionFreelance = this.respUsuarioComisionFreelance;
  }

  validarSiTieneIndicadorFreelance(row: any) {
    this.cargarUsuarioComisionFreelance();
    if (!this.usuarioComisionFreelance || !row.idUsuarioComisionFreelance) {
      return false;
    }
    const usuario = this.autServicio.obtenerUsuario();
    if (this.usuarioComisionFreelance.idUsuarioComisionFreelance !== row.idUsuarioComisionFreelance ||
      (usuario.indicadorFreelance && this.usuarioComisionFreelance.indicadorHabilitado)) {
      return false;
    }
    return true;
  }

  verRadicar(data: any) {
    return !!this.estRoles.find(x => x.idEstado === data.idEstado && !!this.rolUsuario.find(y => y === x.codigoRol));
  }

  validarEstadoContact(idEstado: string) {
    return !!this.lisCentroLlamadaEstados.find(x => x.idEstado === idEstado);
  }

  async continuar(data: any, condicionActualizar: any) {
    if (!this.permisos.gestionarFlujo) {
      this.nav.setMesage(0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('GESTIONCOMERCIAL.MSG_NOTIENEPERMISOS')
      });
      return;
    }

    if (data.idProceso) {
      this.gestionarProceso(data);
      return;
    }

    if (!data.indicadorCreadoMovil && !data.indicadorComite && !data.indicadorCheckDocumental && data.idProducto && !this.validarCanalRol(data.idEstado, data.idCanal)) {
      this.nav.setMesage(0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('GESTIONCOMERCIAL.MSG_NOEXISTECONFIGURACIONCANALROL')
      });
      return;
    }

    if (data.indicadorComite && !this.permisos.comite) {
      this.nav.setMesage(0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('GESTIONCOMERCIAL.MSG_NOTIENEPERMISOSCOMITE')
      });
      return;
    }

    if (data.indicadorComite && !(await this.consultarFiltroAprobacion(data.idSolicitud))) {
      this.nav.setMesage(0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: !this.consultarAprobacion.mensaje ? this.nav.buscarMensaje('GESTIONCOMERCIAL.MSG_NOSECUENTACONPERMISOS') : this.consultarAprobacion.mensaje
      });
      return;
    }

    const existe = this.lisSolicitudSocket.find(x => x.idSolicitud === data.idSolicitud);
    if (!!existe) {
      const mensajeSwalTerceroOcupado = {
        title: this.nav.buscarMensaje('MSG_GESTIONSOLICITUD'),
        html: await this.translateService.get('MSG_MENSAJEUSUARIOGESTION', {
          value: existe.usuario
        }).toPromise(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        imageUrl: '/assets/images/info.png',
        imageHeight: 64,
        confirmButtonText: this.nav.buscarMensaje('BTN_CERRAR'),
        preConfirm: () => {
        }
      };
      swal(mensajeSwalTerceroOcupado);
      return;
    }
    this.usuarioNotificacionService.actualizarNotificacion(condicionActualizar.idUsuarioNotificacion).subscribe();
    this.router.navigate([data.indicadorCreadoMovil ? ('pys/gestion-comercial/perfilamiento/informacion/' + data.idSolicitud) : (data.indicadorCheckDocumental ? ('pys/gestion-comercial/radicacion/' + data.idSolicitud + '/true') : (data.indicadorComite ? ('pys/gestion-comercial/gestor-comite-credito/' + data.idSolicitud) : ('pys/gestion-comercial/flujo-venta-proceso/editar/' + data.idSolicitud)))]);
  }

  async consultarFiltroAprobacion(idSolicitud: String) {
    this.consultarAprobacion = await this.solServicio.consultarFiltroAprobacion(idSolicitud, false).toPromise();
    return this.consultarAprobacion.cumple
  }

  gestionarProceso(row: any) {
    this.router.navigate(['pys/gestion-comercial/flujo-venta-proceso/tercero/' + row.idTercero + '/' + row.idProceso]);
  }

  validarCanalRol(idEstado: string, idCanal: string) {
    return !!this.lisConfiguracionCanalEstados.find(x => x.idEstado === idEstado && x.idCanal === idCanal);
  }


  obtenerEtiquetaFecha(fechaStr: string): string {
    if (!fechaStr) return '';
    let dia: number, mes: number, anio: number;

    if (fechaStr.includes('-')) {
      const partes = fechaStr.split('-');
      if (partes[0].length === 4) {
        // YYYY-MM-DD
        anio = parseInt(partes[0], 10);
        mes = parseInt(partes[1], 10) - 1;
        dia = parseInt(partes[2].substring(0, 2), 10);
      } else {
        // DD-MM-YYYY
        dia = parseInt(partes[0], 10);
        mes = parseInt(partes[1], 10) - 1;
        anio = parseInt(partes[2].substring(0, 4), 10);
      }
    } else {
      const fechaObj = new Date(fechaStr);
      if (isNaN(fechaObj.getTime())) return fechaStr;
      dia = fechaObj.getDate();
      mes = fechaObj.getMonth();
      anio = fechaObj.getFullYear();
    }

    const fechaNoti = new Date(anio, mes, dia);
    const hoy = new Date();
    const hoyInicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());

    const diffTime = hoyInicio.getTime() - fechaNoti.getTime();
    const diffDays = Math.round(diffTime / (1000 * 3600 * 24));

    if (diffDays === 0) {
      return 'Hoy';
    } else if (diffDays === 1) {
      return 'Ayer';
    } else {
      const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      return `${dia} de ${meses[mes]} del ${anio}`;
    }
  }

  async marcarTodasComoLeidas() {
    if (!this.notificacionesRecibidas || this.notificacionesRecibidas.length === 0) return;
    this.notificacionesRecibidas.forEach(item => {
      item.indicadorLeido = true;
    });
    await firstValueFrom(this.notificacionesGestionesService.marcarNotificacionesLeidas());
    await this.actualizarListas();
  }

  async limpiarNotificaciones() {
    this.conServicio.confirm({
      message: this.nav.buscarMensaje('SARLAFT.MSG_CONFIRMALIMPIAR'),
      header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'cdNotificaciones',
      accept: async () => {
        await firstValueFrom(this.notificacionesGestionesService.limpiarNotificaciones());
        this.notificaciones = [];
        this.notificacionesRecibidas = [];
        this.notificacionesEnEspera = [];
        this.nRecibidas = 0;
        this.nNoLeidas = 0;
        this.nEnviadas = 0;
        this.deshabilitarCarga = true;
      },
      reject: () => {
      }
    });

  }

  async onScroll(event: any) {
    const element = event.target;
    if (this.deshabilitarCarga || this.cargando || this.cargandoMas) {
      return;
    }
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
      await this.loadData();
    }
  }

  async loadData() {
    if (this.deshabilitarCarga || this.cargandoMas) {
      return;
    }
    this.cargandoMas = true;
    this.objLazy.pagina++;
    try {
      let nuevasNotificaciones: NotificacionesPush[] = [];
      const res: NotificacionsGestiones = await firstValueFrom(
        this.notificacionesGestionesService.obtenerNotificacionesUsuario(this.objLazy)
      );
      nuevasNotificaciones = res.data || [];

      if (nuevasNotificaciones && nuevasNotificaciones.length > 0) {
        this.notificaciones = [...(this.notificaciones || []), ...nuevasNotificaciones];
        await this.actualizarListas(true);

        if (nuevasNotificaciones.length < this.objLazy.cantidad) {
          this.deshabilitarCarga = true;
        }
      } else {
        this.deshabilitarCarga = true;
        this.objLazy.pagina--;
      }
    } catch (error) {
      console.error('Error al cargar más notificaciones:', error);
      this.objLazy.pagina--;
    } finally {
      this.cargandoMas = false;
    }
  }
}




